<template>
  <v-dialog :value="value" @input="closePanel">
      <v-card class="notification_panel">
           <v-card-title>
               Notifications
           </v-card-title>
           <v-divider></v-divider>
           <v-card-text v-if="notificationList.length == 0" class="mt-2">
               No notifications
           </v-card-text>
           <v-card-text v-else class="pl-0 pr-0 pb-0">
               <v-list dense>
                    <v-list-item-group
                    >
                    
                     <v-list-item
                        v-for="(item,i) in notificationList"
                        :key="i"
                        @click="onItemClick(item)"
                    >
                        <v-list-item-icon>
                            <v-icon color="primary">
                               store
                            </v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title v-text="item.title" :class="!item.acknowledgement?'unBold':''"></v-list-item-title>
                             <v-list-item-subtitle class="notification-subtitle">
                                    {{item.creationDate}}
                             </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                    
                    </v-list-item-group>
                </v-list>
           </v-card-text>
           <v-divider></v-divider>
            <v-card-actions class="justify-center">
            <v-btn color="primary" small text @click="viewAll">View All Notifications</v-btn>
            </v-card-actions>
      </v-card>
  </v-dialog>
</template>

<script>
export default {
    name:"NotificationPanel",
    props:['value'],
    computed:{
        notificationList(){
            return this.$store.getters.getNotifications;
        }
    },
    methods:{
        closePanel(){
            this.$emit("input",false);
        },
        viewAll(){
            this.$emit("showAllNotifications");
        },
        onItemClick(item){
            this.$emit("openNotification",item);
        }
    }
}
</script>

<style>
.notification_panel {
    position: absolute !important;
    width: 350px !important;
    top: 51px;
    right: 90px !important;
}
.unBold{
    font-weight: normal !important;
}
.notification-subtitle{
    font-size:0.7125rem !important;
    color:rgba(0, 0, 0, 0.5) !important;
}
</style>